import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ld-empty-loans-card',
  imports: [MatButtonModule],
  templateUrl: './empty-loans-card.component.html',
  styleUrl: './empty-loans-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyLoansCardComponent {
  private readonly transloco = inject(TranslocoService);

  readonly message = input(this.transloco.translate('emptyLoansMessage'));

  readonly linkLoanLabel = input(this.transloco.translate('emptyLoansLinkLoan'));

  readonly linkLoan = output<void>();

  protected onLinkLoan(): void {
    this.linkLoan.emit();
  }
}
